// extracted by mini-css-extract-plugin
export default {"pagination":"style_pagination__CZcwN","active":"style_active__yulUk","dots":"style_dots__Zix6w"};